import React from "react";
import { Button } from "@/components/ui/button";
import { formatDate } from "@/lib/api";
import RecordInspector, { useRecordInspector } from "@/components/app/RecordInspector";
import DocumentDrawer from "@/components/app/DocumentDrawer";
import { Files, FolderSimple, ArrowRight } from "@phosphor-icons/react";
import { PanelHeader, EmptyHint, useFetchList } from "./_shared";

export default function DocsPanel({ project }) {
  const inspector = useRecordInspector();
  const { items, loading, err } = useFetchList(`/documents?entity_type=project&entity_id=${project.id}`, [project.id]);
  return (
    <div data-testid={`panel-docs-${project.id}`}>
      <PanelHeader icon={Files} title="Documents" subtitle="Contracts · drawings · reports · evidence"
        action={<DocumentDrawer entityType="project" entityId={project.id} title={`Documents · ${project.name}`}
                 trigger={<Button size="sm" variant="outline">Upload <ArrowRight size={11} className="ml-1" /></Button>} />} />
      {loading && <div className="text-[11px] text-slate-500">Loading…</div>}
      {err && <div className="rounded-md border border-amber-200 bg-amber-50/60 px-2 py-1.5 text-[11px] text-amber-800">{err}</div>}
      {!loading && !err && items.length === 0 && <EmptyHint message="No documents uploaded yet for this project." />}
      {items.length > 0 && (
        <ul className="space-y-1.5">
          {items.slice(0, 15).map((d) => (
            <li key={d.id || d.doc_group_id}
                onClick={() => inspector.open(d, { title: d.file_name || d.title || "Document", subtitle: `${d.doc_type || "—"} · v${d.version_count || 1}` })}
                data-testid={`doc-row-${d.id || d.doc_group_id}`}
                className="flex flex-wrap items-center gap-2 rounded-md border border-slate-200 bg-white px-2 py-1.5 text-sm cursor-pointer hover:bg-slate-50">
              <FolderSimple size={11} className="text-slate-400" />
              <span className="min-w-0 flex-1 truncate">{d.file_name || d.title || "Untitled"}</span>
              {d.doc_type && <span className="font-mono-alt text-[10px] uppercase tracking-wider text-slate-500">{d.doc_type}</span>}
              <span className="font-mono-alt text-[10px] text-slate-500">{formatDate(d.created_at)}</span>
            </li>
          ))}
        </ul>
      )}
      <RecordInspector {...inspector.props} />
    </div>
  );
}
